import { createSelector } from '@ngrx/store';
import * as Utils from '@shared/core/utils';

import { getActiveCardId } from '../getActiveCardId';

export const isActiveIdCardlessType = createSelector(getActiveCardId, (activeId) => Utils.CreditCards.isCardlessType(activeId));
